module.exports = __webpack_public_path__ + "a46901a74aee40e5598b02bbfd508dac.svg";